<div
  class="controls"
  [class.no-leave]="!isLeaveAvailable"
  [class.no-center]="!isCenterControlVisible"
  [class.no-share]="this.user.isCustomer"
  [class.size-md]="isSizeMedium"
  [class.size-lg]="isSizeLarge"
>
  <!-- [class.controls-viwport-xs]="isMobileSize()" -->
  <div class="share-mock"></div>
  <div class="center-controls fx-row fx-align-start" #centerControls>
    <div
      class="control"
      [class.control-disabled]="isMicDisabled()"
      *ngIf="isAudioDeviceAvailable"
    >
      <button
        [attr.aria-label]="
          (isMutedMic ? 'Turn on microphone' : 'Turn off microphone')
            | translate
        "
        aria-haspopup="menu"
        aria-controls="mic-options-menu"
        class="mic-button room-control-min-size"
        #btnMicRef
        avButton
        ofType="icon"
        [color]="isMutedMic ? 'basic' : 'primary'"
        [size]="size"
        [raised]="true"
        id="btn-mute-mic"
        (click)="toggleMute(kindAudio)"
        (keydown)="focus($event, kindAudio)"
        [attr.data-tid]="
          isMutedMic ? 'stream-controls/mic-unmute' : 'stream-controls/mic-mute'
        "
      >
        <av-icon name="mic-mute" mode="dark" *ngIf="isMutedMic"></av-icon>
        <av-icon name="mic" *ngIf="!isMutedMic"></av-icon>
        <div class="volume-wrap">
          <div #volumeElem class="volume"></div>
        </div>
      </button>
      <!-- <button
        *ngIf="isControlOptionsToggleFocus() === kindAudio"
        (click)="controlOptionsToggle(kindAudio)"
        class="control-options-toggle"
        avButton
        size="xxs"
        ofType="icon"
        color="primary"
      >
        <av-icon name="chevron-right" size="sm"></av-icon>
      </button> -->

      <av-tooltip
        *ngIf="isAudioDeviceMissing || isAudioDevicePermissionMissing"
        class="control-error-tooltip"
        [message]="
          isAudioDeviceMissing ? 'No devices available' : 'Permission required'
        "
      >
        <div class="control-error">!</div>
      </av-tooltip>

      <!-- [class.control-options-visible]="isControlOptionsVisible() === kindAudio" -->
      <av-card
        id="mic-options-menu"
        [class.hidden]="isMobile || isOnHold()"
        arrow="bottom"
        [backdrop]="true"
        [menu]="true"
        vAlign="top"
        [popup]="true"
        hAlign="center"
        class="control-options-on-hover"
        type="control-options"
      >
        <av-card-body size="xs" type="container">
          <av-menu>
            <av-menu-item icon="mic" [arrow]="true" [disabled]="isMutedMic">
              {{ activeAudioDevice.label }}

              <av-card sub-menu [backdrop]="false">
                <av-card-body size="xs">
                  <av-menu>
                    <av-menu-item
                      type="radio"
                      (select)="changeDevice(device)"
                      [checked]="device.deviceId === activeAudioDevice.deviceId"
                      *ngFor="let device of audioDevices"
                      data-tid="stream-controls/change-mic"
                    >
                      <span>{{ device.label }}</span>
                    </av-menu-item>
                  </av-menu>
                </av-card-body>
              </av-card>
            </av-menu-item>

            <ng-container *ngIf="isSpeakerAvailable">
              <av-menu-item type="separator"></av-menu-item>
              <av-menu-item icon="speaker" [arrow]="true">
                {{ activeSpeakerDevice.label }}

                <av-card sub-menu [backdrop]="false">
                  <av-card-body size="xs">
                    <av-menu>
                      <av-menu-item
                        type="radio"
                        (select)="changeDevice(device)"
                        [checked]="
                          device.deviceId === activeSpeakerDevice.deviceId
                        "
                        *ngFor="let device of speakerDevices"
                        data-tid="stream-controls/change-speaker"
                      >
                        <span>{{ device.label }}</span>
                      </av-menu-item>
                    </av-menu>
                  </av-card-body>
                </av-card>
              </av-menu-item>
            </ng-container>

            <div *ngIf="isCaptionAvailable">
              <app-captions-control
                [conferenceId]="conferenceId"
                [istream]="istream"
                [stream]="localStream"
              >
              </app-captions-control>
            </div>

            <av-menu-item type="separator"></av-menu-item>
            <av-menu-item
              [disabled]="isMicDisabled()"
              (select)="toggleMute(kindAudio)"
              (keyArrowDown)="muteMicArrowDown()"
              [color]="!isMutedMic ? 'danger' : null"
              data-tid="stream-controls/toggle-mic-mute-menu"
              #muteMicRef
            >
              <span *ngIf="!isMutedMic"
                >{{ "Mute mic" | translate }} <span class="keyboard">a</span>
              </span>
              <span *ngIf="isMutedMic"
                >{{ "Unmute mic" | translate }}
                <span class="keyboard">a</span></span
              >
            </av-menu-item>
          </av-menu>
        </av-card-body>
      </av-card>
    </div>

    <!-- [class.control-has-menu]="!isMobile && !isOnHold" [class.control-has-menu-active]="isMutedCam" -->
    <div
      class="control"
      [class.control-disabled]="isCamDisabled()"
      *ngIf="isVideoDeviceAvailable"
    >
      <button
        [attr.aria-label]="
          (isMutedCam ? 'Turn on camera' : 'Turn off camera') | translate
        "
        avButton
        #btnCamRef
        ofType="icon"
        [color]="isMutedCam ? 'basic' : 'primary'"
        [size]="size"
        [raised]="true"
        class="room-control-min-size"
        id="btn-mute-cam"
        (click)="toggleMute(kindVideo)"
        (keydown)="focus($event, kindVideo)"
        [attr.data-tid]="
          isMutedCam ? 'stream-controls/cam-unmute' : 'stream-controls/cam-mute'
        "
      >
        <av-icon name="cam" *ngIf="!isMutedCam"></av-icon>
        <av-icon name="cam-mute" mode="dark" *ngIf="isMutedCam"></av-icon>
      </button>
      <!-- <button
        *ngIf="isControlOptionsToggleFocus() === kindVideo"
        class="control-options-toggle"
        avButton
        size="xxs"
        ofType="icon"
        color="primary"
      >
        <av-icon name="chevron-right" size="sm"></av-icon>
      </button> -->

      <av-tooltip
        *ngIf="isVideoDeviceMissing || isVideoDevicePermissionMissing"
        class="control-error-tooltip"
        [message]="
          isVideoDeviceMissing ? 'No devices available' : 'Permission required'
        "
      >
        <div class="control-error">!</div>
      </av-tooltip>

      <av-card
        *ngIf="!isMobile && !isCamDisabled()"
        [class.hidden]="isOnHold()"
        arrow="bottom"
        type="control-options"
        class="control-options-on-hover"
        [menu]="true"
        vAlign="top"
        hAlign="center"
        [backdrop]="true"
        [popup]="true"
      >
        <av-card-body size="xs" type="container">
          <av-menu>
            <av-menu-item icon="cam" [arrow]="true" [disabled]="isMutedCam">
              {{ activeVideoDevice.label }}

              <av-card sub-menu [backdrop]="false">
                <av-card-body size="xs">
                  <av-menu>
                    <av-menu-item
                      type="radio"
                      (select)="changeDevice(device)"
                      [checked]="device.deviceId === activeVideoDevice.deviceId"
                      *ngFor="let device of videoDevices"
                      data-tid="stream-controls/change-video"
                    >
                      {{ device.label }}
                    </av-menu-item>
                  </av-menu>
                </av-card-body>
              </av-card>
            </av-menu-item>

            <ng-container *ngIf="isFilterAvailable">
              <av-menu-item type="separator"></av-menu-item>
              <!-- [color]="isFilterOn?'danger': null" -->
              <av-menu-item
                icon="background-effect"
                #effectsMenuItemRef
                [arrow]="true"
                [disabled]="!isFilterEnabled"
                (keyArrowRight)="navigateToEffects()"
              >
                <!-- *ngIf="!isFilterOn" -->
                <span translate>Background effects</span>
                <!-- <span *ngIf="isFilterOn" translate>No Effect</span> -->

                <av-card
                  class="sub-menu-effects"
                  sub-menu
                  [menu]="true"
                  [backdrop]="false"
                >
                  <av-card-body size="xs">
                    <app-background-effects
                      (keyArrowLeft)="navigateOutOfEffects()"
                      #effectsRef
                    ></app-background-effects>
                  </av-card-body>
                </av-card>
              </av-menu-item>
            </ng-container>

            <ng-container *ngIf="isPortraitModeAvailable">
              <av-menu-item type="separator"></av-menu-item>
              <av-menu-item
                [icon]="isPortraitMode ? 'landscape-mode' : 'portrait-mode'"
                (select)="togglePortraitMode()"
                [disabled]="isPortraitModeDisabled"
                data-tid="stream-controls/toggle-portrait-mode"
              >
                <span *ngIf="!isPortraitMode" translate>Portrait mode</span>
                <span *ngIf="isPortraitMode" translate>Default mode</span>
              </av-menu-item>
            </ng-container>

            <av-menu-item type="separator"></av-menu-item>
            <av-menu-item
              [disabled]="isCamDisabled()"
              (select)="toggleMute(kindVideo)"
              [color]="!isMutedCam ? 'danger' : null"
              (keyArrowDown)="muteCamArrowDown()"
              data-tid="stream-controls/toggle-video-mute-menu"
              #muteCamRef
            >
              <span *ngIf="!isMutedCam">
                {{ "Turn camera off" | translate }}
                <span class="keyboard">v</span>
              </span>
              <span *ngIf="isMutedCam">
                {{ "Turn camera on" | translate }}
                <span class="keyboard">v</span>
              </span>
            </av-menu-item>
          </av-menu>
        </av-card-body>
      </av-card>
    </div>

    <div class="control" *ngIf="isSwitchCamAvailable">
      <button
        arial-label="Switch camera"
        avButton
        ofType="icon"
        color="primary"
        [size]="size"
        [raised]="true"
        id="btn-switch-camera"
        [disabled]="isSwitchCamDisabled()"
        class="btn-switch-cam room-control-min-size"
        (click)="switchCam()"
        data-tid="stream-controls/switch-camera"
      >
        <av-icon name="camera-reverse"></av-icon>
      </button>
    </div>

    <!-- <div class="control control-cc" [class.hidden]="!isCaptionVisible" *ngIf="isCaptionAvailable && localStream">
            <app-captions-control [size]="size" [disabled]="isOnHold" [conferenceId]="conferenceId"
                [applicationId]="applicationId" [stream]="localStream">
            </app-captions-control>
        </div> -->

    <div class="control" *ngIf="isHoldEnabled">
      <av-tooltip [enabled]="!isMobile">
        <button
          [attr.aria-label]="'Put call on hold' | translate"
          avButton
          ofType="icon"
          [color]="isOnHold() && isHoldLocal() ? 'basic' : 'primary'"
          [size]="size"
          [raised]="true"
          id="btn-hold"
          [disabled]="isHoldDisabled()"
          (click)="toggleHold()"
          class="room-control-min-size"
          [attr.data-tid]="
            isOnHold() ? 'stream-controls/hold-off' : 'stream-controls/hold-on'
          "
        >
          <ng-container *ngIf="!isOnHold() || (isOnHold() && !isHoldLocal())">
            <av-icon name="pause"></av-icon>
          </ng-container>
          <ng-container *ngIf="isOnHold() && isHoldLocal()">
            <av-icon name="pause" mode="dark"></av-icon>
          </ng-container>
        </button>
        <ng-container tooltipMessage>
          <ng-container>
            {{ "Hold call" | translate }}
            <span class="keyboard keyboard-tooltip">h</span>
          </ng-container>
          <!-- <ng-container *ngIf="!isOnHold() || (isOnHold() && !isHoldLocal())">
            {{ "Hold call" | translate }}
            <span class="keyboard keyboard-tooltip">h</span>
          </ng-container>
          <ng-container *ngIf="isOnHold() && isHoldLocal()">
            {{ "Hold call" | translate }}
            <span class="keyboard keyboard-tooltip">h</span>
          </ng-container> -->
        </ng-container>
      </av-tooltip>
    </div>

    <div
      class="control control-device-capture"
      *ngIf="isDisplayCaptureAvailable && !isMobileSize()"
    >
      <app-display-capture
        [screenStream]="screenStream"
        [size]="size"
      ></app-display-capture>
    </div>

    <div class="control" *ngIf="isCobrowseTerminateAvailable()">
      <av-tooltip message="Stop co-browsing">
        <button
          avButton
          ofType="icon"
          [attr.aria-label]="'Stop co-browsing' | translate"
          data-tid="stream-controls/stop-cobrowse"
          color="basic"
          [size]="size"
          [raised]="true"
          id="btn-stop-cobrowse"
          class="room-control-min-size"
          (click)="terminateCobrowse()"
        >
          <av-icon name="cobrowse" size="md"></av-icon>
        </button>
      </av-tooltip>
    </div>

    <!-- <div class="control">
      <av-tooltip message="AI Assistant">
        <button
          [attr.aria-label]="'Open Assistant' | translate"
          avButton
          color="primary"
          ofType="icon"
          [size]="size"
          [raised]="true"
          id="btn-ai-assistant"
          (click)="toggleAssistant()"
          data-tid="stream-controls/ai-assistant"
        >
          <av-icon name="transcript" size="sm"></av-icon>
        </button>
      </av-tooltip>
    </div> -->

    <div
      class="control"
      [class.control-disabled]="isNudgeDisabled()"
      *ngIf="isNudgeAvailable"
    >
      <av-tooltip message="Nudge">
        <button
          avButton
          ofType="icon"
          [attr.aria-label]="'Nudge' | translate"
          data-tid="stream-controls/nudge"
          color="primary"
          [size]="size"
          [disabled]="isNudgeDisabled()"
          [raised]="true"
          class="room-control-min-size"
          (click)="nudge()"
        >
          <av-icon
            name="hand-wave"
            [class.wave]="isNudging()"
            size="md"
          ></av-icon>
        </button>
      </av-tooltip>
    </div>

    <div class="control" *ngIf="isFileTransferAvailable() && !isMobileSize()">
      <av-tooltip message="Send a file">
        <button
          [attr.aria-label]="'Send a file' | translate"
          avButton
          color="primary"
          ofType="icon"
          [size]="size"
          [raised]="true"
          id="btn-send-file"
          [disabled]="isFileTransferDisabled()"
          (click)="selectFile()"
          class="room-control-min-size"
          data-tid="stream-controls/file-transfer"
        >
          <av-icon name="upload" size="sm"></av-icon>

          <input
            style="display: none"
            #fileInput
            [accept]="allowedFileTypes()"
            name="file-transfer"
            type="file"
            (change)="fileAdded($event)"
          />
        </button>

        <!-- <av-card
        type="control-options"
        arrow="bottom"
        [popup]="true"
        [class.popup-visible]="true"
        vAlign="top"
        hAlign="center"
        [menu]="true"
      >
        <av-card-body size="xs" type="container">
          <av-menu>
            <av-menu-item>
              <span translate>Participant</span>
            </av-menu-item>
          </av-menu>
        </av-card-body>
      </av-card> -->
      </av-tooltip>
    </div>

    <div class="control" *ngIf="isTagAvailable() && !isMobileSize()">
      <av-tooltip message="Tag interaction">
        <button
          [attr.aria-label]="'Tag interaction' | translate"
          avButton
          [color]="isTagOpen() ? 'basic' : 'primary'"
          ofType="icon"
          [size]="size"
          [raised]="true"
          id="btn-tag-interaction"
          (click)="toggleTags()"
          #tagsBtnRef
          class="room-control-min-size"
          data-tid="stream-controls/tag-interaction"
        >
          <av-icon name="tag" size="sm"></av-icon>
        </button>
      </av-tooltip>
      <app-conversation-tags
        [@slideInOut]="true"
        *ngIf="isTagOpen()"
        #tagsRef
        [activeTags]="tags()"
        (dismiss)="toggleTags()"
        (changed)="tagsChanged($event)"
      ></app-conversation-tags>
    </div>

    <div class="control" *ngIf="isMoreActionsEnabled()">
      <av-tooltip message="More actions" [enabled]="!isMobile">
        <button
          [attr.aria-label]="'More actions' | translate"
          avButton
          [color]="isMoreActionsOpen() ? 'basic' : 'primary'"
          ofType="icon"
          [size]="size"
          [raised]="true"
          id="btn-more-actions"
          (click)="toggleMoreActions()"
          #moreActionsBtnRef
          class="room-control-min-size"
          data-tid="stream-controls/more-actions"
        >
          <av-icon name="more-vertical" size="sm"></av-icon>
        </button>
      </av-tooltip>

      <av-card
        id="more-actions-menu"
        arrow="bottom"
        [backdrop]="true"
        [menu]="true"
        vAlign="top"
        [popup]="true"
        hAlign="center"
        [@slideInOut]="true"
        #moreActionsRef
        *ngIf="isMoreActionsOpen()"
        class="control-options-visible"
        type="control-options"
      >
        <av-card-body size="xs" type="container">
          <av-menu>
            <!-- <av-menu-item
            *ngIf="isHoldEnabled"
            icon="pause"
            [arrow]="false"
            [disabled]="isHoldDisabled()"
            (select)="toggleHold()"
          >
            {{ "Hold call" | translate }}
            <span class="keyboard keyboard-tooltip">h</span>
          </av-menu-item> -->

            <app-display-capture
              *ngIf="isDisplayCaptureAvailable"
              [screenStream]="screenStream"
              type="menu-item"
              (click)="isMoreActionsOpen.set(false)"
            ></app-display-capture>

            <av-menu-item
              *ngIf="isFileTransferAvailable()"
              icon="upload"
              (select)="this.isMoreActionsOpen.set(false); selectFile()"
              [disabled]="isFileTransferDisabled()"
            >
              {{ "Send a file" | translate }}
              <input
                style="display: none"
                #fileInput
                [accept]="allowedFileTypes()"
                name="file-transfer"
                type="file"
                (change)="fileAdded($event)"
              />
            </av-menu-item>

            <av-menu-item
              icon="tag"
              *ngIf="isTagAvailable()"
              (select)="toggleTags()"
              [arrow]="false"
            >
              {{ "Tag interaction" | translate }}
            </av-menu-item>
          </av-menu>
        </av-card-body>
      </av-card>

      <app-conversation-tags
        [@slideInOut]="true"
        *ngIf="isTagOpen()"
        #tagsRef
        [activeTags]="tags()"
        (dismiss)="toggleTags()"
        (changed)="tagsChanged($event)"
      ></app-conversation-tags>
    </div>
  </div>

  <av-tooltip
    class="control control-leave"
    [class.control-leave-space]="isCenterControlVisible"
    [enabled]="!user.isAgent"
    message="Leave call"
    *ngIf="isLeaveAvailable"
  >
    <button
      #leave
      class="button-leave room-control-min-size"
      [attr.aria-label]="'Leave call' | translate"
      avButton
      color="danger"
      ofType="icon"
      [size]="size"
      [raised]="true"
      id="btn-leave-call"
      [disabled]="isOnHold()"
      (click)="leaveConference()"
      (keyup)="leaveKeyUp($event)"
      data-tid="stream-controls/leave-call"
    >
      <av-icon name="phone-down"></av-icon>
    </button>

    <av-card
      type="control-options"
      class="control-options-on-hover"
      *ngIf="user.isAgent && !isOnHold()"
      [arrow]="isMobile ? 'bottom-right' : 'bottom'"
      [popup]="true"
      [class.popup-visible]="isLeavePopupOpen()"
      vAlign="top"
      [hAlign]="isMobile ? 'right' : 'center'"
      [menu]="true"
    >
      <av-card-body size="xs" type="container">
        <av-menu *ngIf="!hasMultipleAgents()">
          <av-menu-item
            *ngIf="canTerminate"
            icon="turn-off"
            (select)="terminateConference()"
            data-tid="stream-controls/end-call"
          >
            <span translate>End call</span>
          </av-menu-item>
          <av-menu-item
            *ngIf="!canTerminate"
            icon="exit"
            (select)="exitConference()"
            data-tid="stream-controls/leave-call-menu"
          >
            <span translate>Leave call</span>
          </av-menu-item>
        </av-menu>

        <av-menu *ngIf="hasMultipleAgents()">
          <ng-container *ngIf="!isGuestAgent">
            <av-menu-item
              icon="turn-off"
              (select)="terminateConference()"
              data-tid="stream-controls/end-for-all"
            >
              <span translate>End call for all</span>
            </av-menu-item>
            <av-menu-item type="separator"></av-menu-item>
          </ng-container>
          <av-menu-item
            icon="exit"
            (select)="exitConference()"
            data-tid="stream-controls/leave-call-multiple-agents"
          >
            <span translate>Leave call</span>
          </av-menu-item>
        </av-menu>
      </av-card-body>
    </av-card>
  </av-tooltip>
</div>
